import * as React from 'react';
import {Box, Typography} from "@mui/material";
import {useStyles} from "../Style";
import {getNomElection} from "../Utils";
import Synthese from "../soufflets/Synthese";
import MapEpci from "../soufflets/final/maps/MapEpci";
import SouffletsAnalyse from "../soufflets/final/SouffletsAnalyse";
import GroupByPersonnae from "../soufflets/GroupByPersonnae";
import MapBvs from "../soufflets/final/maps/MapBvs";
import GroupByBvs from "../soufflets/GroupByBvs";
import {listOfComWithProblems} from "./Page2";


export default function Page3({

                                  codeInsee,
                                  resultsGeomIrisByBvsSynthese,
                                  otherResults,
                                  resultsByBvsSynthese,
                                  resultsGeomByBvsSynthese,
                                  showPersonae,
                                  resultsByIris,
                                  resultsByBvs,
                                  resultsParCandidatsByBvs,
                                  resultsParDonneesInseeByBvs,
                                  filterBv,

                                  filterIris,
                                  filterStatus,
                                  setFilterBv,
                                  setFilterIris,
                                  setFilterStatus,
                                  mappingBvArrondissement,
                                  electionType


                              }) {


    return (
        <Box className={"banner"}
             sx={{
            width: "calc(100% - 60px)",
            display: "flex", flexDirection: "column", overflow: "auto",

            padding: "30px 30px 200px 30px",

            alignItems: "flex-start",
            gap: "50px",
            flexShrink: 0
        }}>
            {listOfComWithProblems.includes(codeInsee) &&<Typography sx={{width: "100%", p: 2, backgroundColor: "#d8d7e1", color: "#190891"}}>
                Les données géolocalisées telles que celles des bureaux de vote ou les adresses dépendantes de ces
                bureaux de votes peuvent présenter des incohérences en lien avec la qualité des données sources du
                ministère de l'intérieur.
                Dans ce cas précis, contactez-nous afin que nous puissions tenter de corriger ensemble ces éléments.
                N'hésitez pas à nous contacter à l'adresse <a
                href={"mailto:contact@terrededonnees.fr"}>contact@terrededonnees.fr</a>
            </Typography>}
            <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                <Box sx={{width: '50%'}}>
                    <Typography
                        sx={{
                            color: "#000",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "32px"
                        }}>
                        Résultats du dernier candidat élu
                    </Typography>
                    <Typography
                        sx={{
                            color: "#000",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "32px"
                        }}>
                        dans les bureaux de votes de la commune
                    </Typography>
                </Box>
                <Box sx={{width: '50%', display: "flex", flexDirection: "column", alignItems: "flex-end"}}>
                    <Box
                        sx={{
                            width: "420px",
                            display: "flex",
                            padding: "10px 15px",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            gap: "5px",
                            borderRadius: "10px",
                            background: "#F7F7F7"
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#000",
                                fontSize: "20px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "32px"
                            }}>
                            Légendes
                        </Typography>
                        <Typography
                            sx={{
                                color: "#000",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "24px"
                            }}>
                            Typologie de scores électoraux du dernier candidat élu
                        </Typography>
                        <Box sx={{width: "100%", display: "flex", flexDirection: "column", gap: 1}}>
                            <Box sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            }}>
                                <Box sx={{width: "49%", display: "flex", flexDirection: "row", alignItems: "center"}}>
                                    <Box sx={{
                                        backgroundColor: "#169f4d",
                                        width: "10px",
                                        lineHeight: "24px",
                                        alignSelf: "stretch",
                                        mr: 2
                                    }}>
                                        &nbsp;
                                    </Box>

                                    <Typography
                                        sx={{
                                            color: "#000",
                                            fontSize: "16px",
                                            fontStyle: "normal",
                                            fontWeight: 200,
                                            lineHeight: "24px"
                                        }}>

                                        Large victoire
                                    </Typography>
                                </Box>
                                <Box sx={{width: "49%", display: "flex", flexDirection: "row", alignItems: "center"}}>
                                    <Box sx={{
                                        backgroundColor: "#e4ae0f",
                                        width: "10px",
                                        lineHeight: "24px",
                                        alignSelf: "stretch",
                                        mr: 2
                                    }}>
                                        &nbsp;
                                    </Box>
                                    <Typography
                                        sx={{
                                            color: "#000",
                                            fontSize: "16px",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "24px"
                                        }}>

                                        Courte défaite
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            }}>
                                <Box sx={{width: "49%", display: "flex", flexDirection: "row", alignItems: "center"}}>
                                    <Box sx={{
                                        backgroundColor: "#82ba4d",
                                        width: "10px",
                                        lineHeight: "24px",
                                        alignSelf: "stretch",
                                        mr: 2
                                    }}>
                                        &nbsp;
                                    </Box>
                                    <Typography
                                        sx={{
                                            color: "#000",
                                            fontSize: "16px",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "24px"
                                        }}>

                                        Victoire disputée
                                    </Typography>
                                </Box>
                                <Box sx={{width: "49%", display: "flex", flexDirection: "row", alignItems: "center"}}>
                                    <Box sx={{
                                        backgroundColor: "#dd110e",
                                        width: "10px",
                                        lineHeight: "24px",
                                        alignSelf: "stretch",
                                        mr: 2
                                    }}>
                                        &nbsp;
                                    </Box>

                                    <Typography
                                        sx={{
                                            color: "#000",
                                            fontSize: "16px",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "24px"
                                        }}>

                                        Largue défaite
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>

            </Box>
            <Box sx={{width: "100%", gap: "10px"}}>
                <MapBvs
                    resultsByBvsSynthese={resultsByBvsSynthese}
                    resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                    resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                    resultsByIris={resultsByIris}
                    visible={true}
                    viewMenu={true}
                    setFilterBv={setFilterBv}
                    setFilterIris={setFilterIris}
                    setFilterStatus={setFilterStatus}
                    filterBv={filterBv}
                    filterIris={filterIris}
                    filterStatus={filterStatus}
                    mappingBvArrondissement={mappingBvArrondissement}
                />
                <Box sx={{mt: 2}}>
                    <GroupByBvs resultsByBvsSynthese={resultsByBvsSynthese}
                                resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                                resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                                resultsByBvs={resultsByBvs}
                                resultsParCandidatsByBvs={resultsParCandidatsByBvs}
                                resultsParDonneesInseeByBvs={resultsParDonneesInseeByBvs}
                                resultsByIris={resultsByIris}
                                codeInsee={codeInsee}
                                filterBv={filterBv}
                                filterIris={filterIris}
                                filterStatus={filterStatus}
                                mappingBvArrondissement={mappingBvArrondissement}
                                showPersonae={showPersonae}
                                otherResults={otherResults["byBvs"]}
                                border={false}
                                electionType={electionType}
                    />
                </Box>
            </Box>

        </Box>)
}
